import { useTranslation } from 'next-i18next'
import { FC, memo } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Link } from '~/components/Link'
import { TopicOverview } from '~/types/theory'
import { getIconName, getTopicClassName } from '~/encyclopedia/utils/encyclopedia.utils'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '60vw' }]

interface ChapterButtonProps {
  topic: TopicOverview
  isSelected: boolean
  findNextUrl: (topic: TopicOverview) => string
}

const ChapterButtonComponent: FC<ChapterButtonProps> = ({ topic, isSelected, findNextUrl }) => {
  const { t } = useTranslation('encyclopedia')
  return (
    <Link
      className={
        'pl-4 h-20 flex items-center rounded text-menu ' +
        `${isSelected ? getTopicClassName(topic, 'only-text') : 'text-gray-link'} `
      }
      to={findNextUrl(topic)}
    >
      <ResponsiveImage
        alt={t(getIconName(topic.path).alt)}
        imageClassName="w-10 shrink-0"
        mediaQuery={mediaQuery}
        srcKey={getIconName(topic.path).src}
      />
      <span className="ml-6 text-md leading-7">{topic.h1}</span>
    </Link>
  )
}
export const ChapterButton = memo(ChapterButtonComponent)
